import { Box, SxProps } from '@chronosphereio/chrono-ui';

export const getCommandSymbol = () => {
  // It's okay to use navigator.platform to determine which symbol to recommend.
  // https://developer.mozilla.org/en-US/docs/Web/API/Navigator/platform#examples
  const isMac = navigator.platform.indexOf('Mac') === 0 || navigator.platform === 'iPhone';
  return isMac ? '⌘' : '^';
};

export function AIEditShortcutPill({ sx, children }: { sx?: SxProps; children: React.ReactNode }) {
  return (
    <Box
      component="span"
      height="16px"
      px="3px"
      py="1px"
      fontSize="0.75rem"
      lineHeight="1"
      border="1px solid"
      borderColor="inherit"
      borderRadius={0.75}
      display="flex"
      alignItems="center"
      fontFamily="var(--chrono-font-family-monospace)"
      sx={sx}
    >
      {children}
    </Box>
  );
}
